import { Analytics, type AnalyticsProps } from "@dub/analytics/react";

export function DubAnalytics(props: AnalyticsProps) {
  return <Analytics {...props} />;
}
